import { Component } from "@angular/core";
import { FilterService } from "@progress/kendo-angular-grid";
import { SelectComponent } from '../select/select.component';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

@Component({
    selector: 'chassis-datatable-filter-row-multi-select',
    templateUrl: './multi-select.component.html',
    styleUrls: ['./multi-select.component.scss'],
})
export class MultiSelectComponent extends SelectComponent {
    constructor(filterService: FilterService) {
        super(filterService);
    }

    /**
     * Value changed
     *
     * @param {Array} values
     * @return void
     */
    public valueChange(values: Array<any>): void {
        this.filter = this.removeFilter(this.column.field);

        if (values.length > 0) {
            const filters = [];

            values.forEach((value) => {
                filters.push({
                    field: this.column.field,
                    operator: 'eq',
                    value: value
                });
            });

            const root: CompositeFilterDescriptor = this.filter || {
                logic: 'or',
                filters: []
            };

            if (filters.length) {
                root.filters.push(...filters);
            }

            this.filterService.filter(root);
        } else {
            this.filterService.filter(this.filter);
        }
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/components/filters/row/multi-select/multi-select.component.ts